import Plugin from './index';
import store from '../../../store';

const HISTORY_EVENTS = ['replaceState', 'pushState', 'popstate', 'hashchange'];

class PageViewPlugin extends Plugin {
  name = 'pageView';
  private latestFireUrl = '';

  init() {
    const { spa, enableReport } = store.config;
    if (enableReport) {
      this.reportPV();
      if (spa) {
        HISTORY_EVENTS.forEach(event => window.addEventListener(event, () => {
          this.reportPV();
        }));
      }
    }
  }

  // uin初始化后重新调用pv上报
  onUinChange({ uin, oldUin }: { uin: string, oldUin: string }) {
    const { enableReport } = store.config;
    if (enableReport) {
      if (uin && !oldUin) {
        this.reportPV();
      }
    }
  }

  // 上报pv
  private reportPV() {
    setTimeout(() => {
      const firedUrl = window.location.pathname + window.location.hash;
      // 如果 url 并没有发生变化时，没有必要上报
      if (!this.instance.uin || !firedUrl || firedUrl === this.latestFireUrl) {
        return;
      }

      this.instance.reportAction('page-view');
      this.instance.renderHottag();

      // 记录最新 url
      this.latestFireUrl = firedUrl;
    }, 0);
  }
}

export default PageViewPlugin;
